const MENU_DISCLAIMER_POSITIONS = {
  TOP: 'menu top bar',
  BOTTOM: 'menu bottom bar'
};

export default MENU_DISCLAIMER_POSITIONS;
